import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {getAnalyticsPageName, trackPageChange} from './analytics'

const AnalyticsTracker = () => {
  const location = useLocation()

  useEffect(() => {
    const timer = window.setTimeout(() => {
      trackPageChange(location.pathname, getAnalyticsPageName(location.pathname))
    }, 0)
    return () => window.clearTimeout(timer)
  }, [location.pathname])

  return null
}

export default AnalyticsTracker
